import React, { createContext, useContext, useState, ReactNode } from 'react';

interface BreadCrumbItem {
    id?: string;
    path: string;
    label: string;
    navigate?: () => void;
    active?: boolean;
}

interface BreadCrumbContextType {
  breadList: BreadCrumbItem[];
  setBreadList: (breadList: BreadCrumbItem[]) => void;
  getPreviousBreadList: () => BreadCrumbItem | undefined;
}

const BreadCrumbContext = createContext<BreadCrumbContextType | undefined>(undefined);

export const BreadCrumbProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [breadList, setBreadList] = useState<BreadCrumbItem[]>([]);

  const getPreviousBreadList = (): BreadCrumbItem | undefined => {
    return breadList[breadList.length - 2];
  };

  return (
    <BreadCrumbContext.Provider value={{ breadList, setBreadList, getPreviousBreadList }}>
      {children}
    </BreadCrumbContext.Provider>
  );
};

export const useBreadCrumbContext = () => {
  const context = useContext(BreadCrumbContext);
  if (context === undefined) {
    throw new Error('useBreadCrumbContext must be used within a BreadCrumbProvider');
  }
  return context;
};
